import { Static, Type } from '@sinclair/typebox'

export enum AdminClientStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    MIGRATING = 'MIGRATING',
}

export enum AdminClientProvider {
    KIZEO = 'KIZEO',
    GOOGLE = 'GOOGLE',
}

export const AdminClient = Type.Object({
    id: Type.String(),
    externalCustomerId: Type.Optional(Type.String()),
    name: Type.String(),
    companyName: Type.Optional(Type.String()),
    globalCode: Type.Optional(Type.String()),
    status: Type.Enum(AdminClientStatus),
    provider: Type.Enum(AdminClientProvider),
    isInternalKizeo: Type.Boolean(),
    allowConsent: Type.Boolean(),
    usersCount: Type.Number(),
})

export type AdminClient = Static<typeof AdminClient>

export const ListAdminClientsRequest = Type.Object({
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Number({ default: 20 })),
    search: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    provider: Type.Optional(Type.Enum(AdminClientProvider)),
    isInternalKizeo: Type.Optional(Type.Boolean()),
    status: Type.Optional(Type.Array(Type.Enum(AdminClientStatus))),
})

export type ListAdminClientsRequest = Static<typeof ListAdminClientsRequest>

export const GetAdminClientParams = Type.Object({
    id: Type.String(),
})

export type GetAdminClientParams = Static<typeof GetAdminClientParams>
